import { CardTitle, cn } from "@atlas/core";
import {
  getCheckoutCartEntryOuterClassName,
  type IOrderedCartEntry,
} from "@utils";
import type { ReactNode } from "react";

export interface ICheckoutCartEntryBlockProps {
  entry: Pick<IOrderedCartEntry, "group" | "matchedToSolutionInCart">;
  showNestedAddonsHeading: boolean;
  showOtherAddonsHeading: boolean;
  nestedAddonsTitle: ReactNode;
  otherAddonsTitle: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * Shared shell: section headings + outer indentation rail for cart lines
 * (checkout page and header cart popover).
 */
export function CheckoutCartEntryBlock({
  entry,
  showNestedAddonsHeading,
  showOtherAddonsHeading,
  nestedAddonsTitle,
  otherAddonsTitle,
  children,
  className,
}: ICheckoutCartEntryBlockProps) {
  const { group, matchedToSolutionInCart } = entry;

  return (
    <div
      className={cn(
        "flex w-full min-w-0 flex-col gap-2",
        getCheckoutCartEntryOuterClassName(group, matchedToSolutionInCart),
        className,
      )}>
      {showNestedAddonsHeading ? (
        <CardTitle>{nestedAddonsTitle}</CardTitle>
      ) : null}
      {showOtherAddonsHeading ? (
        <CardTitle>{otherAddonsTitle}</CardTitle>
      ) : null}
      {children}
    </div>
  );
}
